export const API_ADDRESS = {
    createCampaign:'createCampaign',
    offer: 'offer',
    dashBoardApi:"dashBoardApi",
    sendApproval:'sendApproval',
    templateEmail: 'templateEmail',
    getCampaignData:'getCampaignData',
    getCampaignStatus:'getCampaignStatus',
    addCampaignData:'getCampaignData',
    campaignAdded:'campaignAdded',
    searchCampaignStore: 'searchCampaignStore',
    addedCampaignStore: 'addedCampaignStore',
    addCampaignStore: 'addCampaignStore',
    deleteCampaignStore: 'deleteCampaignStore',
    getScheduleCampaign: 'getScheduleCampaign',
    scheduleCampaign: 'scheduleCampaign',
    groupCampaign: 'groupCampaign',
    toggleMode:'toggleMode',
    addGroupCampaign: 'addGroupCampaign',
    deleteGroupCampaign: 'deleteGroupCampaign',
    searchCampaign: 'searchCampaign',
    campaign: 'campaign',
    templateCampign: 'templateCampign',
    templateSms:'templateSms',
    getWhatsapp: 'whatsapp',
    campaignOffer: 'campaignOffer',
    campaignSubmit:'campaignSubmit',
    store: 'store',
    searchStore: 'searchStore',
    addUser : 'addUser',
    viewUser : "viewUser",
    userDetails : "userDetails",
    updateUser:"updateUser",
    addAccountType : "addAccountType",
    accountType : "accountType",
    createOffer:"createOffer",
    viewOffer : "viewOffer",
    OfferDetails : "OfferDetails",
    editOffer: 'editOffer',
    addOffer: "addOffer",
    previewDetails: "previewDetails",
    editStore: "editStore",
    deleteStore:"deleteStore",
    deleteOffer:"deleteOffer",
    deleteUser:"deleteUser",
    updateStore:"updateStore",
    imageUpload:"imageUpload",
      
    
    
    

}
